import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { MenuHomepageComponent } from './pages/menu-homepage/menu-homepage.component';
import { LandingpageComponent } from './pages/landingpage/landingpage.component';
import { MenuSuccessPageComponent } from './pages/menu-successpage/menu-successpage.component';

/**
 * Стол по коду: `/T/<код>` и `/t/<код>` (ручной ввод) — раньше маршрута
 * `/:restaurantId/:tableId`, иначе «T» приняли бы за заведение
 */
export function tableCodeMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  return segments.length === 2 && segments[0].path.toLowerCase() === 't'
    ? { consumed: segments, posParams: { code: segments[1] } }
    : null;
}

const routes: Routes = [
  // { path: '', component: LandingpageComponent },
  { path: '', component: MenuHomepageComponent },
  { path: 'demo/success', component: MenuSuccessPageComponent },
  { matcher: tableCodeMatcher, component: MenuHomepageComponent },
  // Заведение по id (UUID) или slug — разбирает MenuHomepageComponent
  { path: ':restaurantId', component: MenuHomepageComponent },
  { path: ':restaurantId/:tableId', component: MenuHomepageComponent },
  { path: ':restaurantId/:tableId/success', component: MenuSuccessPageComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
